import { TableCellWithBadge } from "../../../../data-model/tableCells";

/**
 * Builds the standard black "View" badge button used in Summary, Log, and Order Status columns.
 *
 * @input isDisabled - Whether the View action should be disabled
 * @return TableCellWithBadge: Badge button cell value
 */
export const getBlackViewBadge = (
  isDisabled = false,
): TableCellWithBadge => ({
  text: "View",
  color: "#FFFFFF",
  bgColor: "#111111",
  isDisabled,
});
